import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Empty } from 'antd';

const messages = {
  date: 'Data',
  time: 'Tempo',
  event: 'Evento',
  allDay: 'Dia todo',
  week: 'Semana',
  work_week: 'Semana de trabalho',
  day: 'Dia',
  month: 'Mês',
  previous: 'Voltar',
  next: 'Próximo',
  yesterday: 'Ontem',
  tomorrow: 'Amanhã',
  today: 'Hoje',
  agenda: 'Agenda',
  noEventsInRange: (
    <div className="gx-d-flex gx-justify-content-center gx-mt-3">
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    </div>
  ),
  showMore: (count) => `Exibir todos - total ${count + 1}`
};

export default messages;
